import { useQuery } from '@tanstack/react-query'
import config from '@config'

import { EntityType, SportEntity } from '@utils/entities'

interface UseEntitySubscriptionsProps {
  enabled?: boolean
  entityType: EntityType
}

export interface SportEntitySubscription extends SportEntity {
  channel: string
}

type SportEntitySubscriptionsAPIResponse = SportEntitySubscription[]

const {
  publication: { publication },
} = config

const apiUrl = new URL('https://mock.test.blick.ch/entity-subscriptions')

apiUrl.searchParams.set(
  'publication',
  publication === 'blick' ? 'blick' : 'blick-romandie'
)

const fetchEntitySubscriptionsData = async ({
  entityType,
}: UseEntitySubscriptionsProps) => {
  const requestUrl = new URL(apiUrl.toString())

  requestUrl.searchParams.set('entityType', entityType)

  const response = await fetch(requestUrl.toString())

  if (!response.ok) {
    throw new Error('Error fetching entity subscriptions data.')
  }

  return response.json() as Promise<SportEntitySubscriptionsAPIResponse>
}

const useSportEntitySubscriptions = ({
  enabled,
  entityType,
}: UseEntitySubscriptionsProps) => {
  return useQuery({
    queryKey: ['sport-entity-subscriptions', entityType],
    queryFn: async () =>
      fetchEntitySubscriptionsData({
        entityType,
      }),
    enabled,
  })
}

export default useSportEntitySubscriptions
